import { KotlinLoggingConfiguration_getInstance2pq6qv2bwynbv as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function isLoggingEnabled(_this__u8e3s4) {
  return _this__u8e3s4.b2_1 >= KotlinLoggingConfiguration_getInstance().i2g_1.b2_1;
}
//region block: exports
export {
  isLoggingEnabled as isLoggingEnabled1soazpld6peik,
};
//endregion

//# sourceMappingURL=KotlinLoggingLevel.mjs.map
